import type { ClickReleaseConfig } from './types';

/**
 * Bundled default configuration — the low-precedence layer. The embedding client's `config`
 * (passed to `init`) deep-overrides these. See DESIGN.md for the precedence rules.
 */
export const DEFAULT_CONFIG: ClickReleaseConfig = {
  title: "What's new",
  surface: 'modal',
  indicator: { side: 'top-right', mode: 'dot' },
  toast: { placement: 'bottom-right', duration: 6000 },
  banner: { placement: 'top', dismissible: true },
  theme: { mode: 'auto', colors: {}, vars: {} },
  locale: 'en',
  language: 'en',
  reducedMotion: 'auto',
};
